import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-quantity"
export default class extends Controller {
  static targets = [
    "input",
    "productTotal",
    "installationTotal",
    "installationCheckbox",
    "distanceInput",
    "travelTotal",
    "grandTotal",
  ]
  static values = { unitPriceCents: Number, stock: Number, installationPriceCents: Number }

  // Keep these in sync with CartItem::FREE_TRAVEL_KM / TRAVEL_COST_PER_KM_CENTS
  static FREE_TRAVEL_KM = 30
  static TRAVEL_COST_PER_KM_CENTS = 80

  connect() {
    this.recalculate()
  }

  increment() {
    this.inputTarget.value = this.clamp(this.currentQuantity + 1)
    this.recalculate()
  }

  decrement() {
    this.inputTarget.value = this.clamp(this.currentQuantity - 1)
    this.recalculate()
  }

  recalculate() {
    this.inputTarget.value = this.clamp(this.currentQuantity)
    const qty = this.currentQuantity

    const productTotalCents = this.unitPriceCentsValue * qty
    this.productTotalTarget.textContent = this.formatMoney(productTotalCents)

    let grandTotalCents = productTotalCents
    const installationChecked = this.hasInstallationCheckboxTarget && this.installationCheckboxTarget.checked

    if (this.hasInstallationTotalTarget) {
      const installationTotalCents = this.installationPriceCentsValue * qty
      this.installationTotalTarget.textContent = this.formatMoney(installationTotalCents)

      if (installationChecked) {
        grandTotalCents += installationTotalCents
      }
    }

    if (this.hasTravelTotalTarget) {
      const travelCents = this.travelCostCents
      this.travelTotalTarget.textContent = this.formatMoney(travelCents)

      if (installationChecked) {
        grandTotalCents += travelCents
      }
    }

    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatMoney(grandTotalCents)
    }
  }

  get currentQuantity() {
    return parseInt(this.inputTarget.value, 10) || 1
  }

  get travelCostCents() {
    if (!this.hasDistanceInputTarget) return 0

    const distanceKm = parseInt(this.distanceInputTarget.value, 10) || 0
    const billableKm = Math.max(distanceKm - this.constructor.FREE_TRAVEL_KM, 0)
    return billableKm * this.constructor.TRAVEL_COST_PER_KM_CENTS
  }

  clamp(quantity) {
    const max = this.stockValue > 0 ? this.stockValue : 1
    return Math.min(Math.max(quantity, 1), max)
  }

  formatMoney(cents) {
    const euros = (cents / 100).toFixed(2).replace(".", ",")
    return `€${euros}`
  }
}
